import { IonContent, IonPage, IonImg, useIonViewDidLeave } from '@ionic/react';
import { useContext, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { PdfContext } from '../components/PdfViewer';

const SafetySyllabus: React.FC = () => {
  const { setModalVisible, setDesktopPdf, setMobilePdf } = useContext(PdfContext);
  const [swiper, setSwiper] = useState<SwiperCore>();
  // set the swiper slide to the first one when the component is mounted
  useIonViewDidLeave(() => {
    swiper?.slideTo(0);
  }, [swiper]);
  return (
    <>
      <IonPage>
        <IonContent fullscreen>
          <Swiper
            initialSlide={0}
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            onSwiper={(swiper) => setSwiper(swiper)}
            slidesPerView={1}
            // loop={true}
            navigation
            pagination={{ clickable: true }}
            spaceBetween={0}
            centeredSlides={true}
            breakpoints={{
              768: {
                slidesPerView: 1.2,
                spaceBetween: -20
              },
              1024: {
                slidesPerView: 1.4,
                spaceBetween: -120
              },
            }}
          >
            <SwiperSlide>
              <div className="container-inner">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#ff00c2', color: '#fff' }}>Silabus Keamanan</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030', paddingTop: '0.1rem' }}>
                    <p>
                      Bertemu dengan orang baru pasti menyenangkan selama kamu mengutamakan keamanan!<br /><br />Simak petunjuk lengkap ini untuk menikmati pengalaman online dating dengan berhati-hati, baik secara online atau offline. Pembahasannya lengkap, mulai dari Kesadaran, Batasan & Consent, dan berbagai hal lainnya.
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="container-inner design-one">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#fd5466', color: '#fff' }}>Pusat Keamanan</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030' }}>
                    <p className='hide-desktop'>Keamanan yang utama</p>
                    <IonImg className="hide-mobile" src='assets/img/safety-seminar-thumb-01.jpg'></IonImg>
                    <IonImg className="hide-desktop" src='assets/img/safety-seminar-thumb-01-mobile.jpg'></IonImg>
                    <div className='flex'>
                      <p className='hide-mobile' style={{ maxWidth: '550px' }}>Keamanan yang utama</p>
                      <button onClick={() => {
                        setDesktopPdf("/assets/pdf/ID_Safety.pdf");
                        setMobilePdf("/assets/pdf/ID_Safety(m).pdf");
                        setModalVisible(true);
                      }} style={{ color: "#fff", background: "#fd5466" }}>Stay Safe!</button>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="container-inner design-one">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#186ac4', color: '#fff' }}>Belajar Tentang Consent</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030' }}>
                    <p className='hide-desktop'>Panduan tentang cara menetapkan dan menyampaikan batasan kamu dengan jelas!</p>
                    <IonImg src='assets/img/safety-consent-thumb-01.png'></IonImg>
                    <div className='flex'>
                      <p className='hide-mobile' style={{ maxWidth: '550px' }}>Panduan tentang cara menetapkan dan menyampaikan batasan kamu dengan jelas!</p>
                      <button onClick={() => {
                        setDesktopPdf("/assets/pdf/ID_Consent.pdf");
                        setMobilePdf("/assets/pdf/ID_Consent(m).pdf");
                        setModalVisible(true);
                      }} style={{ color: "#fff", background: "#186ac4" }}>Dapatkan consent!</button>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </IonContent>
      </IonPage>
    </>
  );
};

export default SafetySyllabus;
